module.exports = __webpack_public_path__ + "img/horizontal_4_2_3016.89402081.png";